import { TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { ServiceLocator } from '../../app/ServiceLocator';
import { cssClass } from '../../style';
import { IDataSourceDetailInfo } from '../../ts/models/IDataSourceInfo';
import { DataSources } from '../../ts/resources/Datasources';
import { DataRoleSubspaceProps } from '../types/DataRoleSubspaceProps';
import { DefinitionSubspaceAboutSection } from './DefinitionSubspaceAboutSection';
import { DefinitionSubspaceValuesSection } from './DefinitionSubspaceValuesSection';

const cssPrefix = 'DataRoleDefinitionSubspace';

const containerClass = cssClass(cssPrefix, 'container', {
  boxSizing: 'border-box',
  marginLeft: TabStyles.Spacing.ExtraLargeSpace,
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
});

export interface DataRoleDefinitionSubspaceState {
  readonly loadedParentDatasource?: IDataSourceDetailInfo;
}

export class DefinitionSubspace extends React.PureComponent<DataRoleSubspaceProps, DataRoleDefinitionSubspaceState> {
  private DatasourcesService: DataSources;
  public state: DataRoleDefinitionSubspaceState = {};
  public constructor(props: DataRoleSubspaceProps) {
    super(props);
    this.DatasourcesService = (ServiceLocator.get('DataSources'));
  }

  public componentDidMount() {
    if (!this.props.dataRoleDetailInfo.valueSource) { return; }
    this.DatasourcesService
    .getById(this.props.dataRoleDetailInfo.valueSource.datasourceId)
    .then((datasource: IDataSourceDetailInfo) => this.setState({loadedParentDatasource: datasource}));
  }

  public render(): JSX.Element {
    return <div className={containerClass}>
      <DefinitionSubspaceAboutSection
        dataTypes={this.props.dataRoleDetailInfo.dataTypes}
        datasource={this.state.loadedParentDatasource}
        sourceField={this.props.dataRoleDetailInfo.valueSource && this.props.dataRoleDetailInfo.valueSource.fieldName}
        description={this.props.dataRoleDetailInfo.description}
        siteUrls={this.props.siteUrls}
      />
      <DefinitionSubspaceValuesSection
        valuesList={this.props.dataRoleDetailInfo.values}
        valueCount={this.props.dataRoleDetailInfo.valueCount}/>
    </div>;
  }
}
